import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Inside } from '../models/inside';


@Injectable({
  providedIn: 'root'
})
export class InsideService extends BaseService<Inside>  {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string                
  ) { 
    super(http,rootUrl,'Plasard/Inside');
  }
}